export default __webpack_public_path__ + "static/media/scenario-designer.d7d25f40.md";